import React,{useState} from "react";
import { useReactTable, getCoreRowModel, getFilteredRowModel, getSortedRowModel, getExpandedRowModel, flexRender } from "@tanstack/react-table";
import { Icon } from "@fluentui/react";
import { GlobalFilter, DefaultFilterForColumn } from "./Filter";
import { t } from "i18next";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";

import './Table.css';

export default function Table(props) {
    let columns = props.columns;
    let data = props.data;
    let customSortFunction = props.handleClick;
    const [globalFilter, setGlobalFilter] = useState('');
    const [sorting, setSorting] = useState([]);
    const [expanded, setExpanded] = useState({});
    
  const table = useReactTable({
    columns,
    data,
    state: {
      globalFilter,
      sorting,
      expanded,
    },
    onGlobalFilterChange: setGlobalFilter,
    onSortingChange: setSorting,
    onExpandedChange: setExpanded,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
    manualPagination: true,
    getSubRows: props.getSubRows,
  });

  const headerGroups = table.getHeaderGroups();
  const rows = table.getRowModel().rows;
  const preGlobalFilteredRows = table.getPreFilteredRowModel().rows;

 

  return (
    <div>
    {props.tableName==null||props.tableName==undefined?<>
      <GlobalFilter
            preGlobalFilteredRows={preGlobalFilteredRows}
            globalFilter={globalFilter}
            setGlobalFilter={setGlobalFilter}
            style={{marginBottom: 20}}
      />
    </>
    
    :props.showGlobalFilter?
        <div style={{display:'flex',justifyContent:'space-between'}}>
            <div>{props.tableName}</div>
            <GlobalFilter
              preGlobalFilteredRows={preGlobalFilteredRows}
              globalFilter={globalFilter}
              setGlobalFilter={setGlobalFilter}
              style={{marginBottom: 20}}
            />
        </div>
        :<></>}

    <table style={{width:"100vw"}}>
      <thead className={`${!isMobile ? "table-thead" : ""}`}>
        {headerGroups.map((headerGroup) => {
           return (<tr key={headerGroup.id}>
             {headerGroup.headers.map((column) => {
              return (<th key={column.id} 
              >
                {column.isPlaceholder
                  ? null
                  : flexRender(
                      column.columnDef.header,
                      column.getContext()
                    )}{" "}
                
                {column.columnDef.sorting?column.getIsSorted()
                  ? column.getIsSorted() === 'desc'
                    ? 
                    <Icon key={column.id} iconName="SortUp" className="ms-fontSize-12"></Icon>
                    :
                    <Icon key={column.id} iconName="SortDown" className="ms-fontSize-12"></Icon>                    
                    : <> 
                    <Icon key={column.id} iconName="Sort" className="ms-fontSize-12"></Icon>
                    </>:<></>
                }
             
              </th>)
              
            })}
           </tr>)
})}
      </thead>
     <tbody
     className={`${
         !isMobile ? "table-tbody modal-scroll" : "table-tbody modal-scroll"
       }`}
     >
        {rows.length > 0 && rows.map((row) => {
          return (
           
            <tr key={row.id} style={row.depth == 1?{background:'#80808033'}:row.depth==2?{background:'#80808096'}:null} className={`${!isMobile ? "table-tr" : ""}`} >
              {row.getVisibleCells().map((cell) => {
                return <td  key={cell.id} style={cell.column.columnDef.rowStyle}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>;
              })}
            </tr>
          );
        return <></>
        })
    }
      </tbody>
    </table>
    {rows.length==0 &&<p style={{textAlign:'center',paddingTop:'10px'}}>{t("table.no-result-found")}</p>}
    </div>
    
  );
}